module.exports = __webpack_public_path__ + "img/comstu1.fe45294e.jpeg";